import { SET_ACTIVE_WIDGET } from '@/store/actions/layouteditor';

export default {
  props: {
    id: {
      type: [String, Number],
    },
    data: {
      type: Object,
    },
  },
  mounted() {
    this.$refs.widget.enabled = true;
    this.setActiveWidget();
  },
  methods: {
    setActiveWidget() {
      this.$store.dispatch(SET_ACTIVE_WIDGET, this.id);
      this.$events.fire('set-active-widget-properties', {
        id: this.id,
        component: this.component,
      });
      this.$events.fire('set-widgets-manager-active-item', {
        id: this.id,
      });
    },
    resizeStop(x, y, width, height) {
      const payload = {
        data: [
          {
            path: 'style',
            key: 'x',
            value: x,
          },
          {
            path: 'style',
            key: 'y',
            value: y,
          },
          {
            path: 'style',
            key: 'w',
            value: width,
          },
          {
            path: 'style',
            key: 'h',
            value: height,
          },
        ],
      };

      this.$store.dispatch(`widget${this.id}/UPDATE_WIDGET`, payload);
    },
    dragStop(x, y) {
      const payload = {
        data: [
          {
            path: 'style',
            key: 'x',
            value: x,
          },
          {
            path: 'style',
            key: 'y',
            value: y,
          },
        ],
      };

      this.$store.dispatch(`widget${this.id}/UPDATE_WIDGET`, payload);
    },
    rotateStop(rotation) {
      const payload = {
        data: [
          {
            path: 'style',
            key: 'r',
            value: rotation,
          },
        ],
      };

      this.$store.dispatch(`widget${this.id}/UPDATE_WIDGET`, payload);
    },
  },
};
